import { Box } from '@mui/material';
import { AuthService } from '../../../services/auth.service';
import RoleLensBoard from './RoleLensBoard';
import StoreAdminDashboard from '../StoreAdminDashboard';

/**
 * The Thread style of the store home: requisitions as steps from request to issue, low stock and expiring lots.
 * The server scopes everything to the stores the caller is in charge of, so this stays a thin wrapper.
 */
export default function StoreLensBoard() {
    const institutionId = AuthService.getSelectedInstitution();
    return (
        <Box sx={{ minWidth: 0 }} data-help-page="dashboard.thread.store">
            <RoleLensBoard institutionId={institutionId} lens="store" fallback={<StoreAdminDashboard />} />
        </Box>
    );
}
